import { useState, useEffect } from 'react';
import './CustomAlert.css';

const CustomAlert = ({ text }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (text) {
            // Добавляем небольшую задержку перед показом, чтобы начальные стили применились
            const showTimer = setTimeout(() => {
                setIsVisible(true);
            }, 10); // Задержка 10ms

            // Скрываем через 2 секунды
            const hideTimer = setTimeout(() => {
                setIsVisible(false);
            }, 2010); // 2000ms + 10ms задержка

            return () => {
                clearTimeout(showTimer);
                clearTimeout(hideTimer);
            };
        }
    }, [text]);

    if (!text) return null;

    return (
        <div className={`customAlert ${isVisible ? 'customAlert--visible' : 'customAlert--hidden'}`}>
            {text}
        </div>
    );
};

export default CustomAlert;